export const TAB_LABEL = {
    OVERVIEW: "Overview",
    DETAILS: "Details",
    DOCUMENTS: "Documents",
    MATTER_DOCUMENTS: "Matter Document",
    RECENTLY_MODIFIED: "Recently Modified",
    MATTER_STARRED: "My Starred",
    FINANCIALS: "Financials",
    BUDGETS: "Budgets",
    INVOICES: "Invoices",
    PEOPLE: "People",
    NOTES: "Notes",
    LINE_ITEMS: "Line Items",
    FEES: "Fees",
    EXPENSES: "Expenses",
    TIMELINE: "Timeline",
    ASSOCIATED_MATTERS: "Associated Matters",
    RATE_HISTORY: 'Rate History',
    MATTER_SPECIFIC_RATES: "Matter Specific Rates",
    PRACTICE_AREA_RATES: "Practice Area Rates",
    MATTERS: 'Matters',
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    REJECTED: "Rejected",
    PENDING: "Pending",
    ALL_INVOICES: "All Invoices",
    INVOICES_NEEDING_ACTION: "Invoices Needing Action",
    PROCESS_STATUS: "Process Status",
    PRODUCTS: "Products",
    UPLOAD_INVOICE: "Upload Invoice",
    AFAS: "AFAs",
    AFA_TERMS: "AFA Terms",
    PORTFOLIO: "Portfolios"
}
